import store from '@Store';

import { showGlobalSpinnerType, hideGlobalSpinnerType } from './GlobalSpinnerConstants';

export function showGlobalSpinner(type) {
  return {
    type: showGlobalSpinnerType,
    payload: {
      type,
    },
  };
}

export function hideGlobalSpinner() {
  return {
    type: hideGlobalSpinnerType,
  };
}

export function dispatchShowGlobalSpinner(type) {
  return store.dispatch(showGlobalSpinner(type));
}

export function dispatchHideGlobalSpinner() {
  return store.dispatch(hideGlobalSpinner());
}
